/** The API stores an issuer hostname, even when the operator pastes a page URL. */
export function issuerDomain(value: string): string | null {
  const input = value.trim()
  if (!input || (input.includes("://") && !/^https?:\/\//i.test(input)))
    return null
  try {
    const url = new URL(
      /^https?:\/\//i.test(input) ? input : `https://${input}`,
    )
    if (
      !["http:", "https:"].includes(url.protocol) ||
      url.username ||
      url.password
    )
      return null
    const hostname = url.hostname.toLowerCase().replace(/^www\./, "")
    const labels = hostname.split(".")
    return hostname.length <= 253 &&
      labels.length >= 2 &&
      labels.every((label) =>
        /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(label),
      )
      ? hostname
      : null
  } catch {
    return null
  }
}
